import { useCallback, useEffect, useRef, useState } from 'react';
import { explain } from './api';

export function useLive<T>(loader: () => Promise<T>, key: string, interval = 20_000) {
  const [state, setState] = useState<{ key: string; data: T | null; error: string; loading: boolean }>({ key, data: null, error: '', loading: true });
  const [tick, setTick] = useState(0);
  const latest = useRef(loader); latest.current = loader;
  useEffect(() => {
    let active = true, running = false;
    const load = async () => {
      if (!active || running) return;
      running = true;
      setState(old => old.key === key ? { ...old, loading: !old.data } : { key, data: null, error: '', loading: true });
      try { const data = await latest.current(); if (active) setState({ key, data, error: '', loading: false }); }
      catch (error) { if (active) setState(old => ({ key, data: old.key === key ? old.data : null, error: explain(error), loading: false })); }
      finally { running = false; }
    };
    void load();
    const timer = setInterval(() => { if (document.visibilityState === 'visible') void load(); }, interval);
    return () => { active = false; clearInterval(timer); };
  }, [key, interval, tick]);
  return { ...(state.key === key ? state : { data: null, error: '', loading: true }), refresh: useCallback(() => setTick(value => value + 1), []) };
}
